import getPusherAuthHeaders from './getPusherAuthHeaders.js';

export const reportPusherConnectionLifecycle = ({ baseApi, bearerToken, event }) => {
  if (!bearerToken) {
    return;
  }

  try {
    const pendingRequest = fetch(`${baseApi}/v1/auth/pusher/connection-lifecycle`, {
      method: 'POST',
      headers: {
        ...getPusherAuthHeaders(bearerToken),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(event)
    });
    Promise.resolve(pendingRequest).catch(() => undefined);
  } catch {}
};
